module.exports = __webpack_public_path__ + "static/media/svg-1.8a4e3bbf.svg";